import { render, staticRenderFns } from "./EditEventTypesModal.vue?vue&type=template&id=1aab64bf&"
import script from "./EditEventTypesModal.vue?vue&type=script&lang=ts&"
export * from "./EditEventTypesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports